<template>
  <div class="card-311">
    <div class="card-311-main-content  d-flex">
      <span class="card-311-title">
      <slot name="p-1">ماشرومی زینگر</slot>
    </span>
      <span class="card-311-dot"></span>
      <span>
      <slot name="p-2">25,000 toman</slot>
    </span>
    </div>

    <div class="card-311-description">
      <slot name="p-3">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda blanditiis corporis distinctio dolor
          dolore
          doloribus, eligendi eos error, illum ipsam iste labore modi nihil obcaecati perferendis quidem sequi voluptas
          voluptate!
        </p>
      </slot>
    </div>

  </div>
</template>

<script>
import mA from '../Tags/A'
import mImg from '../Tags/Img'
import {CardProps} from "./CardProps";

export default {
  name: "Card311",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps
  },

}

</script>

<style scoped>
.card-311-main-content {
  align-items: center;
  flex-basis: 100%;
  font-size: 19px;
  font-weight: 600;
  margin-bottom: 10px;
  justify-content: space-between;
}

.card-311-dot {
  font-size: 19px;
  font-weight: 600;
  box-sizing: border-box;
  border-bottom-color: var(--dark);
  flex-grow: 1;
  margin-left: 10px;
  margin-right: 10px;
  height: 0;
  border-bottom-style: dotted;
  border-bottom-width: 2px;
}

</style>